
import EHeader from "./eHeader/index.vue";
import EFooter from "./eFooter.vue";

import { defineComponent } from "vue";
import { provideScrollToTopFunc } from "@/hooks/useScrollbar";
import { provideReloadFunc } from "@/hooks/useReload";
import { useRoute } from "vue-router";
import { SHINSEI_LIST } from "@/constants/componentName.constant";
export default defineComponent({
  name: "Home",
  components: {
    EHeader,
    EFooter,
  },
  setup() {
    const scrollbar = provideScrollToTopFunc();
    const isRouterAlive = provideReloadFunc();
    const route = useRoute();
    //keep-aliveしたいcompを設定
    const keepAliveComp = [SHINSEI_LIST];
    return {
      scrollbar,
      isRouterAlive,
      route,
      keepAliveComp,
    };
  },
});
